<template>
    <IOContainer
        :maxHeight="maxHeight"
        class="text-body-large font-weight-medium text-typography1"
    >
        <EWRCard
            v-if="record.output.errors"
            v-for="error in record.output.errors"
            type="error"
            :text="error"
            class="mb-2"
        />
        <EWRCard
            v-if="record.output.warnings"
            v-for="warning in record.output.warnings"
            type="warning"
            :text="warning"
            class="mb-2"
        />
        <EWRCard
            v-if="record.output.remarks"
            v-for="remark in record.output.remarks"
            type="remark"
            :text="remark"
            class="mb-2"
        />

        <OutputResults :record="record" :calc="calc" />
    </IOContainer>
</template>
<script setup>
import EWRCard from './EWRCard.vue'
import OutputResults from './OutputResults.vue'
import IOContainer from '../shared/IOContainer.vue'

const props = defineProps({
    record: {
        type: Object,
        required: true,
    },
    calc: {
        type: Object,
        required: true,
    },
    maxHeight: {
        type: String,
        default: '100%',
    },
})
</script>
